module.exports = __webpack_public_path__ + "img/m31tripod_thumb.b3631f0c.jpg";